import { markdownify } from '@src/utils';
import React, { Component } from 'react';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
class DetailsTopTabs extends Component {
	constructor() {
		super();
		this.state = {
			open: false,
			nav1: null,
			nav2: null,
		};
	}
	render() {
		const { item } = this.props;
		const hasDescription = item.fullDescription || item.shortDescription;

		return (
			<section className="tab-product mt-0">
				<div className="row">
					<div className="col-sm-12 col-lg-12">
						<Tabs className="tab-content nav-material table-responsive">
							<TabList className="nav nav-tabs nav-material">
								{item.brand ? (
									<Tab className="nav-item">
										<span className="nav-link">
											<i className="icofont icofont-ui-home" />
											Brand Details
										</span>
										<div className="material-border" />
									</Tab>
								) : (
									''
								)}

								{item?.productSpecifications?.length > 0 && (
									<Tab className="nav-item">
										<span className="nav-link">
											<i className="icofont icofont-ui-home" />
											Specifications
										</span>
										<div className="material-border" />
									</Tab>
								)}

								{hasDescription && (
									<Tab className="nav-item">
										<span className="nav-link">
											<i className="icofont icofont-man-in-glasses" />
											Description
										</span>
										<div className="material-border" />
									</Tab>
								)}
								{item.videoUrl && (
									<Tab className="nav-item">
										<span className="nav-link">
											<i className="icofont icofont-contacts" />
											Video
										</span>
										<div className="material-border" />
									</Tab>
								)}
							</TabList>

							{item.brand && (
								<TabPanel>
									<div className="brand-description">
										<a target="_blank" rel="noopener noreferrer" href={item.brand.website}>
											<img src={item.brand.imageUrl} alt="brandimage" />
										</a>
										<p>{item.brand.longDescription ? item.brand.longDescription : ''}</p>
									</div>
								</TabPanel>
							)}

							{item?.productSpecifications?.length > 0 && (
								<TabPanel className="tab-pane fade show active">
									<table className="table">
										<tbody>
											<tr key="header">
												<th>Specification</th>
												<th>Value</th>
											</tr>

											{item?.productSpecifications?.map((spec, i) => {
												return (
													<tr key={i}>
														<th>{spec.specificationAttribute.name}</th>
														{spec.specificationValue.startsWith('http') ? (
															<td>
																<a
																	href={spec.specificationValue}
																	target="_blank"
																	rel="noreferrer">
																	View {spec.specificationAttribute.name}
																</a>
															</td>
														) : (
															<td>{spec.specificationValue}</td>
														)}
													</tr>
												);
											})}
										</tbody>
									</table>
								</TabPanel>
							)}

							{hasDescription && (
								<TabPanel>
									<div className="description">
										<p>
											{markdownify(
												item.fullDescription ? item.fullDescription : item.shortDescription
											)}
										</p>
									</div>
								</TabPanel>
							)}

							{item.videoUrl && (
								<TabPanel>
									<div className="mt-4 text-center">
										<div className="embed-responsive embed-responsive-16by9">
											<iframe
												title={'Video for Product ' + item.name}
												src={item.videoUrl}
												allow="autoplay; encrypted-media" // TODO: setup Iframe tp autoplay on focus...
												allowFullScreen
											/>
										</div>
									</div>
								</TabPanel>
							)}
						</Tabs>
					</div>
				</div>
			</section>
		);
	}
}

export default DetailsTopTabs;
